import { createStore } from 'vuex'

/**
 * Plugins
 */

import prescriptionJustificationPlugin from '@/store/plugins/prescriptionJustification'
import systemStoragePlugin from '@/store/plugins/systemStorage'
import userStoragePlugin from '@/store/plugins/userStorage'

/**
 * Modules
 */
import clinical from './modules/clinicalStore'
import general from './modules/generalStore'
import patient from './modules/patientStore'
import prescription from './modules/prescriptionStore'
import recommendations from './modules/recommendationsStore'
import configs from './modules/remoteConfigsStore'
import results from './modules/resultsStore'
import system from './modules/systemStore'
import user from './modules/userStore'

export default createStore({
  strict: false,
  modules: {
    system,
    general,
    user,
    prescription,
    patient,
    clinical,
    recommendations,
    results,
    configs,
  },
  plugins: [
    userStoragePlugin.plugin,
    systemStoragePlugin.plugin,
    prescriptionJustificationPlugin,
  ],
})
